import { Col, Divider, Row, theme } from 'antd';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import BarChart from '../../../../components/DashboardPage/BarChart';
import InfoBox from '../../../../components/DashboardPage/InfoBox';
// import PieChart from '../../../../components/DashboardPage/PieChart';
// import ReportTable from '../../../../components/DashboardPage/ReportTable';
import { generateReportQueryStringFromQuery } from '../TicketReport/TicketReportFiltersContainer';

const ChatReportItemsContainer = () => {
    const {
        token: { marginMD }
    } = theme.useToken();

    const { query } = useRouter();
    const { t } = useTranslation('reports');
    const queryString = generateReportQueryStringFromQuery(query);
    return (
        <>
            <Row style={{ justifyContent: 'space-evenly' }} gutter={[marginMD / 2, marginMD / 2]}>
                <InfoBox
                    url={queryString ? `/reports/chat/total-chat-count?${queryString}` : null}
                    title={t('chatReports.reportItems.totalCountOfChat')}
                />
                <InfoBox
                    url={queryString ? `/reports/chat/solved-chat-tickets?${queryString}` : null}
                    title={t('chatReports.reportItems.totalCountOfResolvedChat')}
                />
                <InfoBox
                    url={queryString ? `/reports/chat/total-chat-duration?${queryString}` : null}
                    title={t('chatReports.reportItems.totalDurationOfChat')}
                />
                <InfoBox
                    url={queryString ? `/reports/chat/average-chat-duration?${queryString}` : null}
                    title={t('chatReports.reportItems.totalAverageOfChatDuration')}
                />
                <InfoBox
                    url={queryString ? `/reports/chat/first-response-time?${queryString}` : null}
                    title={t('chatReports.reportItems.initialContactTime')}
                />
                {/* <InfoBox
                    url={ queryString ?`/reports/chat/timeout-ended-chats?${queryString}`: null}
                    title={t('chatReports.reportItems.chatsEndedByTimeout')}
                />
                <InfoBox
                    url={ queryString ?`/reports/chat/user-ended-chats?${queryString}`: null}
                    title={t('chatReports.reportItems.chatsEndedByUser')}
                /> */}
                <InfoBox
                    url={queryString ? `/reports/chat/missing-chat-count?${queryString}` : null}
                    title={t('chatReports.reportItems.missedChats')}
                />
                {/* <InfoBox
                    url={ queryString ?`/reports/chat/satisfaction-score?${queryString}`: null}
                    title={t('chatReports.reportItems.averageSatisfactionScore')}
                /> */}
            </Row>
            <Divider />
            <Row style={{ justifyContent: 'space-evenly' }}>
                {/* <Col span={10}>
                    <PieChart
                        url={ queryString ?`/reports/chat/number-of-survey-responses?${queryString}`: null}
                        title={t('chatReports.reportItems.numberOfSurveyResponses')}
                    />
                </Col> */}
                <Col span={20}>
                    <BarChart
                        url={queryString ? `/reports/chat/chat-count-per-hour?${queryString}` : null}
                        title={t('chatReports.reportItems.numberOfChatsPerHour')}
                    />
                </Col>
            </Row>
            <Divider />
            {/* <Row justify="space-evenly" style={{ gap: '10px 10px' }}>
                <Col span={20}>
                    <ReportTable
                        url={ queryString ?`/reports/chat/url-info?${queryString}`: null}
                        title={t('chatReports.reportItems.urlInfo')}
                    />
                </Col>
            </Row> */}
        </>
    );
};

export default ChatReportItemsContainer;
